import React, { useState, useEffect } from "react";
import {
  Wrapper,
  WrapperTitle,
  WrapperForm,
  Label,
  Input,
  WrapperWarning,
  BtnRegister,
  Slider,
  Delivery,
  Container,
  InputPrice,
} from "./styled";
import MyDropzone from "../../atoms/Dropzone";
import { useNavigate } from "react-router-dom";
import { useUserAuth } from "../../../request/hooks/Auth";
import { createService } from "../../../services/InsertService";
import { useLoading } from "../../../request/hooks/Loading";
import { useTheme } from "../../../request/hooks/Theme";
import { useDrop } from "../../../request/hooks/Dropzone";
import { storage } from "../../../services/Firebase";
import InputSelect from "../../atoms/Select";
import Modal from "../../atoms/Modal";
import cat from "../../../request/mock/categorias.json";
import IntlCurrencyInput from "react-intl-currency-input";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import check from "../../../assets/img/checkIcon.png";

const RegisterService = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { profile } = useUserAuth();
  const { dropzone } = useDrop();
  const [display, setDisplay] = useState(false);
  const { setLoading } = useLoading();
  const [click, setClick] = useState(false);
  const [data, setData] = useState({
    nome: null,
    autor: profile?.username,
    desc: null,
    entrega: 1,
    categoria: null,
    img: "",
    preco: null,
    uid: profile?.uid,
  });
  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };
  const customStyles = {
    singleValue: (base) => ({
      ...base,
      color: theme.colors.fontColor,
    }),

    control: (provided) => ({
      ...provided,
      width: "15rem",
      height: "3.3rem",
      border: "3px solid #24D39A",
      backgroundColor: "transparent",
      color: "#24D39A !important",
      boxShadow: "none",
    }),
    menuList: (base) => ({
      ...base,

      "::-webkit-scrollbar": {
        width: "4px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#24D39A",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: theme.colors.fontColor,
    }),
    multiValue: (styles) => {
      return {
        ...styles,
        color: theme.colors.fontColor,
      };
    },
  };

  useEffect(() => {
    if (data.preco) {
      createService(
        data.autor,
        data.categoria,
        data.desc,
        data.entrega,
        data.img,
        data.nome,
        data.preco,
        data.uid
      );
      setDisplay(true);
    }
  }, [click]);

  const handleChange = (event, value) => {
    event.preventDefault();
    setData({ ...data, preco: value });
  };

  const handleUpload = () => {
    if (!dropzone) return;

    setLoading(true);
    const storageRef = ref(storage, `images/${dropzone.name}`);
    const uploadTask = uploadBytesResumable(storageRef, dropzone);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      },
      (error) => {
        console.log(error);
        setLoading(false);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          setData({ ...data, img: url });
          console.log(url);
          setLoading(false);
          setClick(true);
        });
      }
    );
  };

  const newService = () => {
    handleUpload();
  };

  return (
    <Wrapper color={theme.colors.fontColor}>
      <WrapperTitle color={theme.colors.fontColor}>
        Registre um novo serviço
      </WrapperTitle>
      <WrapperForm color={theme.colors.fontColor}>
        <Label>Nome do serviço:</Label>
        <Input
          color={theme.colors.fontColor}
          placeholder="Nome do serviço"
          onChange={(e) =>
            setData({
              ...data,
              nome: e.target.value,
              uid: profile?.uid,
              autor: profile?.username,
            })
          }
        />
        <Label>Imagem do serviço:</Label>
        <MyDropzone />
        <Label>Descrição do serviço:</Label>
        <Input
          color={theme.colors.fontColor}
          placeholder="Faça uma breve descrição sobre o serviço..."
          onChange={(e) => setData({ ...data, desc: e.target.value })}
        />
        <Container color={theme.colors.fontColor}>
          <div className="box">
            <Label>Categoria:</Label>

            <InputSelect
              style={customStyles}
              placeholder="Selecione uma categoria"
              options={cat}
              onChange={(e) => setData({ ...data, categoria: e.value })}
            />
          </div>

          <div className="box">
            <Label>Valor:</Label>

            <IntlCurrencyInput
              component={theme.name === "dark" ? Input : InputPrice}
              currency="BRL"
              max="1000"
              min="5"
              placeholder="Valor do serviço (R$)"
              config={currencyConfig}
              onChange={handleChange}
              value={data.preco}
            />
          </div>
        </Container>
        <Label>Entrega do serviço:</Label>
        <Slider
          type="range"
          min="1"
          max="30"
          onChange={(e) =>
            setData({ ...data, entrega: parseInt(e.target.value) })
          }
        />
        <Delivery color={theme.colors.fontColor}>
          {data.entrega}
          <p> Dia{data.entrega > 1 ? "s" : ""}</p>
        </Delivery>
        <WrapperWarning color={theme.colors.fontColor}>
          Após registrar o serviço é impossível realizar alteração no campo de
          imagem.{" "}
        </WrapperWarning>
        {data.nome && data.preco && data.desc && data.categoria ? (
          <BtnRegister
            onClick={() => newService()}
            color={theme.colors.fontColor}
          >
            Registrar serviço
          </BtnRegister>
        ) : (
          <BtnRegister disabled>Registrar serviço</BtnRegister>
        )}
      </WrapperForm>

      <Modal
        labelBntConfirm={"Checar!"}
        display={display}
        confirm={() => {
          navigate(`/servicos`);
          setLoading(false);
        }}
        oneBtn
      >
        <img
          src={check}
          style={{ width: "80px", height: "80px", marginTop: "30px" }}
        />
        <p style={{ fontSize: "18px", fontWeight: "bold", marginTop: "50px" }}>
          Seu serviço foi criado!
        </p>
      </Modal>
    </Wrapper>
  );
};

export default RegisterService;
